import { defineStore } from "pinia";

export type MerchantToastTone = "success" | "warning" | "error" | "info";

export interface MerchantToast {
  id: string;
  message: string;
  tone: MerchantToastTone;
}

let toastSequence = 0;

export const useMerchantToastStore = defineStore("merchant-toasts", {
  state: (): { toasts: MerchantToast[] } => ({
    toasts: [],
  }),
  actions: {
    show(message: string, tone: MerchantToastTone = "info"): void {
      if (this.toasts.some((toast) => toast.message === message && toast.tone === tone)) return;

      const toast = { id: nextToastId(), message, tone };
      this.toasts = [toast, ...this.toasts].slice(0, 4);
      window.setTimeout(() => this.dismiss(toast.id), 5_000);
    },
    success(message: string): void {
      this.show(message, "success");
    },
    warning(message: string): void {
      this.show(message, "warning");
    },
    error(message: string): void {
      this.show(message, "error");
    },
    dismiss(id: string): void {
      this.toasts = this.toasts.filter((toast) => toast.id !== id);
    },
  },
});

function nextToastId(): string {
  toastSequence += 1;
  return `${crypto.randomUUID()}-${toastSequence}`;
}
